const PUBLIC_CHECKOUT_TOKEN = /^[A-Za-z0-9]{16}$/;

export function checkoutIdentifier(product) {
  if (product && PUBLIC_CHECKOUT_TOKEN.test(product.checkout_hash || "")) {
    return product.checkout_hash;
  }

  return product && (product.id || product.product_id);
}

export function legacyCheckoutIdentifier(product) {
  return product && (product.id || product.product_id);
}

export function tokenizedCheckoutIdentifier(product) {
  if (product && PUBLIC_CHECKOUT_TOKEN.test(product.checkout_hash || "")) {
    return product.checkout_hash;
  }

  return null;
}

export function buildCheckoutUrl(baseUrl, product, options = {}) {
  const identifier = options.identifier === "legacy"
    ? legacyCheckoutIdentifier(product)
    : options.identifier === "tokenized"
      ? tokenizedCheckoutIdentifier(product)
      : checkoutIdentifier(product);
  if (!identifier) return "";

  const normalizedBaseUrl = (baseUrl || "").replace(/\/$/, "");
  let url = `${normalizedBaseUrl}/${identifier}`;

  if (options.offerHash) {
    url += `/offer/${encodeURIComponent(options.offerHash)}`;
  }

  const params = new URLSearchParams();
  Object.entries(options.query || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.set(key, value);
    }
  });

  const query = params.toString();
  return query ? `${url}?${query}` : url;
}

export function buildLegacyCheckoutUrl(baseUrl, product, options = {}) {
  return buildCheckoutUrl(baseUrl, product, {
    ...options,
    identifier: "legacy",
  });
}

export function buildTokenizedCheckoutUrl(baseUrl, product, options = {}) {
  return buildCheckoutUrl(baseUrl, product, {
    ...options,
    identifier: "tokenized",
  });
}

export function buildCheckoutUrls(baseUrl, product, options = {}) {
  return {
    legacy: buildLegacyCheckoutUrl(baseUrl, product, options),
    tokenized: buildTokenizedCheckoutUrl(baseUrl, product, options),
  };
}

export function rebaseCheckoutUrl(baseUrl, url) {
  if (!url) return "";

  try {
    const normalizedBaseUrl = (baseUrl || "").replace(/\/$/, "");
    const parsedUrl = new URL(url, `${normalizedBaseUrl}/`);
    return `${normalizedBaseUrl}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch (error) {
    return url;
  }
}

export function buildCardUpdateUrl(baseUrl, product, options = {}) {
  const identifier = checkoutIdentifier(product);
  if (!identifier) return "";

  return buildCheckoutUrl(`${(baseUrl || "").replace(/\/$/, "")}/assinatura`, product, options);
}

export function buildLegacyCardUpdateUrl(baseUrl, product, options = {}) {
  return buildLegacyCheckoutUrl(`${(baseUrl || "").replace(/\/$/, "")}/assinatura`, product, options);
}

export function buildTokenizedLegacyCardUpdateUrl(baseUrl, product, options = {}) {
  return buildTokenizedCheckoutUrl(`${(baseUrl || "").replace(/\/$/, "")}/assinatura`, product, options);
}
